import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'

import { HttpClient } from "@angular/common/http"
import { Usuario } from '../clases/usuario';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  private usuario$: BehaviorSubject<Usuario[]> = new BehaviorSubject<Usuario[]>([]);

  constructor(private _http: HttpClient) { }

  centroCosto(IdEmpresa: any) {
    const url = environment.URL_BASE + 'centrocosto/getempresa' + "?id=" + IdEmpresa
    return this._http.get(url)
  }

  centroCostoV2(IdEmpresa: any) {
    const url = environment.URL_BASE + 'centrocosto/getempresa' + "?id=" + IdEmpresa
    return this._http.get(url)
  }

  centroCostoAsociado(strData: any) {
    // console.log(strData)
    const url = environment.URL_BASE + 'centrocosto/ObtenerCCXCliente'
    return this._http.post(url, strData)
  }

  empresa(id: number) {
    const url = environment.URL_BASE + 'empresa/all' + "?id=" + id
    return this._http.get(url)
  }

  perfil(idUsuario: number) {
    const url = environment.URL_BASE + 'rol/all' + "?id=" + idUsuario
    return this._http.get(url)
  }


  listarUsuarios(obj: any) {
    const url = environment.URL_BASE + 'cliente/filter';
    return this._http.post(url, obj).pipe(
      map( (res: any) => {
        this.usuario$.next(res.data);
        return res;
      })
    )
  }

  getUsuarios(){
    console.log(this.usuario$, ["GET USUARIOS SERVICE"]);
    
    return this.usuario$;
  }

  getUsuario(id: number | string){
   // console.log("get Usuario");
    
    return this.getUsuarios().pipe(
      map( listaUsuarios => listaUsuarios.find(usuario => usuario.IdCliente === +id))
    );
  }

  GuardarUsuario(usuario: Usuario) {
    const url = environment.URL_BASE + 'cliente/save'
    return this._http.post(url, usuario)
  }

  listarArea(IdEmpresa: any) {
    const url = environment.URL_BASE + 'cliente/listarArea' + "?idEmpresa=" + IdEmpresa
    return this._http.get(url)
  }

  listarSupervisor(IdEmpresa: any, IdCentroCosto: any) {
    const url = environment.URL_BASE + "cliente/getSupervisores?idEmpresa=" + IdEmpresa + "&idCentroCosto=" + IdCentroCosto
    return this._http.get(url)
  }

  saldo(idCliente){
    const url = environment.URL_BASE +"presupuesto/saldo?idCliente="+ idCliente;
    return this._http.get(url)
  }

  exportExcel(data: any){
    const url = environment.URL_REPORTE_EXCEL + 'reportes/usuariosTodos';
    // return this._http.post(url,data);
       return this._http.post(url, data,{headers: {}, responseType: "blob" });
  }

  // exportExcel(idEmpresa: number, rol: number, activo: number, id_centro_costo: number): Observable<Blob> {
  //   const url = environment.URL_EXCEL+idEmpresa+'&Rol='+rol+'&Activo='+activo+'&IdCentroCosto='+id_centro_costo

  //   return this._http.get(url, { responseType: 'blob' }).pipe(
  //     map(((res: Blob) => new Blob(([res]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })

  //     )));
  // }
  cambiarEstadoUsuarios(data: any){
    const url = environment.URL_BASE +"cliente/desactivarCliente";
    return this._http.post(url,data)
  }

  GetClienteEncargo(Email:any){
    const url = environment.URL_BASE +"cliente/GetClienteEncargo?Email="+Email;
    return this._http.get(url)
  }
}
